import { h, Component } from 'preact'
import _ from './styles.sass'

import colorScale from '@root/lib/colorScale'
import { latestValue, yearMeanValue } from '@root/lib/valuesFromStation'

export default class StationSelector extends Component {
  handleInput = (e) => {
    this.context.actions.selectMarker({ byIndex: +e.target.value })
  }

  captureEvent = (e) => {
    e.stopPropagation()
  }

  render () {
    const { id, allStations, selectedStationIndex, selectedDataset } = this.props
    const numberOfStations = allStations.length
    const showDayData = selectedDataset === 'day'

    const selectorProps = {
      min: 0,
      max: numberOfStations - 1,
      step: 1,
      value: selectedStationIndex
    }

    const stationRadius = 100 / numberOfStations / 2

    const selectedStation = allStations[selectedStationIndex]
    const selectedStaionOffset = selectedStationIndex * stationRadius * 2 + stationRadius
    const selectedStaionValue = showDayData ? latestValue(selectedStation) : yearMeanValue(selectedStation)
    const selectedStaionColor = colorScale(selectedStaionValue)

    return <div class={_.wrapper}>
      <input id={id} {...selectorProps} class={_.stationSelector} type='range' onTouchStart={this.captureEvent} onInput={this.handleInput} onChange={this.handleInput} />
      <svg class={_.cricles} viewBox={`${-stationRadius - 1} -1 ${100 + stationRadius * 2 + 2} ${stationRadius * 4 + 2}`}>
        { allStations
          .map((station, i) => {
            const offset = i * stationRadius * 2 + stationRadius

            const value = showDayData ? latestValue(station) : yearMeanValue(station)
            const color = colorScale(value)

            return <circle cx={offset} cy={stationRadius * 2} r={stationRadius - 0.4} fill='transparent' stroke={color} strokeWidth='0.2' />
          })
        }
        <circle cx={selectedStaionOffset} cy={stationRadius * 2} r={stationRadius * 1.5} fill={selectedStaionColor} stroke='white' strokeWidth='0.5' />
      </svg>
    </div>
  }
}
